import React, { useState, useEffect, useCallback, useRef }  from 'react';
// import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
// import './index.scss';

import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { useSelector, useDispatch } from 'react-redux';
import { getVendorRiskBusinessImpact, resetVendorRiskBusinessImpact } from "../../../../../../store/actions/thirdPartyRiskAction";

const VendorRiskVsBusinessImpact = ({customerId}) =>{

    const vendorRiskBusinessImpactResponse = useSelector((state) => state.thirdPartyRisk.vendorRiskBusinessImpact);
    
    const prevCustomerIdRef = useRef(null);

    const dispatch = useDispatch();

    // const [vendorRiskBusinessImpact, setVendorRiskBusinessImpact] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    //heat map values
    const [criticalGreaterThan800, setCriticalGreaterThan800] = useState([]);
    const [criticalBetween800And600, setCriticalBetween800And600] = useState([]);
    const [criticalBetween600And400, setCriticalBetween600And400] = useState([]);
    const [criticalBetween400And250, setCriticalBetween400And250] = useState([]);
    const [criticalLessThan250, setCriticalLessThan250] = useState([]);

    const [highGreaterThan800, setHighGreaterThan800] = useState([]);
    const [highBetween800And600, setHighBetween800And600] = useState([]);
    const [highBetween600And400, setHighBetween600And400] = useState([]);
    const [highBetween400And250, setHighBetween400And250] = useState([]);
    const [highLessThan250, setHighLessThan250] = useState([]);

    const [mediumGreaterThan800, setMediumGreaterThan800] = useState([]);
    const [mediumBetween800And600, setMediumBetween800And600] = useState([]);
    const [mediumBetween600And400, setMediumBetween600And400] = useState([]);
    const [mediumBetween400And250, setMediumBetween400And250] = useState([]);
    const [mediumLessThan250, setMediumLessThan250] = useState([]);

    const [lowGreaterThan800, setLowGreaterThan800] = useState([]);
    const [lowBetween800And600, setLowBetween800And600] = useState([]);
    const [lowBetween600And400, setLowBetween600And400] = useState([]);
    const [lowBetween400And250, setLowBetween400And250] = useState([]);
    const [lowLessThan250, setLowLessThan250] = useState([]);

    const fetchVendorRiskBusinessImapct = useCallback(()=>{
        setIsLoading(true)
        dispatch(getVendorRiskBusinessImpact(customerId))
    },[customerId, dispatch])

    useEffect(()=>{
        if(customerId !== prevCustomerIdRef.current) {
            fetchVendorRiskBusinessImapct();
            prevCustomerIdRef.current = customerId;
        }
    },[customerId, fetchVendorRiskBusinessImapct])

    useEffect(()=>{
        if(vendorRiskBusinessImpactResponse !== null){

            setCriticalGreaterThan800(vendorRiskBusinessImpactResponse?.stats?.organizations?.critical.filter(item => item.stats.overall_score.overall_score > 800));            
            setCriticalBetween800And600(vendorRiskBusinessImpactResponse?.stats?.organizations?.critical.filter(item => item.stats.overall_score.overall_score <= 800 && item.stats.overall_score.overall_score > 600));
            setCriticalBetween600And400(vendorRiskBusinessImpactResponse?.stats?.organizations?.critical.filter(item => item.stats.overall_score.overall_score <= 600 && item.stats.overall_score.overall_score > 400));
            setCriticalBetween400And250(vendorRiskBusinessImpactResponse?.stats?.organizations?.critical.filter(item => item.stats.overall_score.overall_score <= 400 && item.stats.overall_score.overall_score > 250));
            setCriticalLessThan250(vendorRiskBusinessImpactResponse?.stats?.organizations?.critical.filter(item => item.stats.overall_score.overall_score <= 250));

            setHighGreaterThan800(vendorRiskBusinessImpactResponse?.stats?.organizations?.high.filter(item => item.stats.overall_score.overall_score > 800));            
            setHighBetween800And600(vendorRiskBusinessImpactResponse?.stats?.organizations?.high.filter(item => item.stats.overall_score.overall_score <= 800 && item.stats.overall_score.overall_score > 600));
            setHighBetween600And400(vendorRiskBusinessImpactResponse?.stats?.organizations?.high.filter(item => item.stats.overall_score.overall_score <= 600 && item.stats.overall_score.overall_score > 400));
            setHighBetween400And250(vendorRiskBusinessImpactResponse?.stats?.organizations?.high.filter(item => item.stats.overall_score.overall_score <= 400 && item.stats.overall_score.overall_score > 250));
            setHighLessThan250(vendorRiskBusinessImpactResponse?.stats?.organizations?.high.filter(item => item.stats.overall_score.overall_score <= 250));

            setMediumGreaterThan800(vendorRiskBusinessImpactResponse?.stats?.organizations?.medium.filter(item => item.stats.overall_score.overall_score > 800));            
            setMediumBetween800And600(vendorRiskBusinessImpactResponse?.stats?.organizations?.medium.filter(item => item.stats.overall_score.overall_score <= 800 && item.stats.overall_score.overall_score > 600));
            setMediumBetween600And400(vendorRiskBusinessImpactResponse?.stats?.organizations?.medium.filter(item => item.stats.overall_score.overall_score <= 600 && item.stats.overall_score.overall_score > 400));
            setMediumBetween400And250(vendorRiskBusinessImpactResponse?.stats?.organizations?.medium.filter(item => item.stats.overall_score.overall_score <= 400 && item.stats.overall_score.overall_score > 250));
            setMediumLessThan250(vendorRiskBusinessImpactResponse?.stats?.organizations?.medium.filter(item => item.stats.overall_score.overall_score <= 250));

            setLowGreaterThan800(vendorRiskBusinessImpactResponse?.stats?.organizations?.low.filter(item => item.stats.overall_score.overall_score > 800));            
            setLowBetween800And600(vendorRiskBusinessImpactResponse?.stats?.organizations?.low.filter(item => item.stats.overall_score.overall_score <= 800 && item.stats.overall_score.overall_score > 600));
            setLowBetween600And400(vendorRiskBusinessImpactResponse?.stats?.organizations?.low.filter(item => item.stats.overall_score.overall_score <= 600 && item.stats.overall_score.overall_score > 400));
            setLowBetween400And250(vendorRiskBusinessImpactResponse?.stats?.organizations?.low.filter(item => item.stats.overall_score.overall_score <= 400 && item.stats.overall_score.overall_score > 250));
            setLowLessThan250(vendorRiskBusinessImpactResponse?.stats?.organizations?.low.filter(item => item.stats.overall_score.overall_score <= 250));

            dispatch(resetVendorRiskBusinessImpact())
            setIsLoading(false)
        }
    },[vendorRiskBusinessImpactResponse, dispatch])

    return (
        <>
            <div className="bg-white-with-shadow p-4 h-100">
                {
                    isLoading ?
                    <SkeletonLoader type={"line"} count={7} currentPage={"dashboardOverview"} />
                    :
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <div className="header-content d-flex justify-content-between dashboard-box-container mb-4">
                            <p className="heading">Third-Party Vendors Risk vs. Business Impact</p>
                        </div>
                        <div className="heat-map-container d-flex gap-3">
                            <div className="header-content dashboard-box-container d-flex justify-content-between align-items-center">

                                <p className="heading dashboard-heading">Risk Levels</p>
                            </div>
                            <div className="risk-graph">
                                <div className="row-first-div d-flex align-items-center main-row-container">
                                    <div className="score-value-div d-flex align-items-center">
                                        <p>801-900</p>
                                    </div>
                                    <div className="row-common-div row-one-one d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{lowGreaterThan800?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-one-two d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{mediumGreaterThan800?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-one-three d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{highGreaterThan800?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-one-four d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{criticalGreaterThan800?.length || 0}</p>
                                    </div>
                                </div>
                                <div className="row-two-div d-flex align-items-center main-row-container">
                                    <div className="score-value-div d-flex align-items-center">
                                        <p>601-800</p>
                                    </div>
                                    <div className="row-common-div row-two-one d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{lowBetween800And600?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-two-two d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{mediumBetween800And600?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-two-three d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{highBetween800And600?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-two-four d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{criticalBetween800And600?.length || 0}</p>
                                    </div>
                                </div>
                                <div className="row-three-div d-flex align-items-center main-row-container">
                                    <div className="score-value-div d-flex align-items-center">
                                        <p>401-600</p>
                                    </div>
                                    <div className="row-common-div row-three-one d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{lowBetween600And400?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-three-two d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{mediumBetween600And400?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-three-three d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{highBetween600And400?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-three-four d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{criticalBetween600And400?.length || 0}</p>
                                    </div>
                                </div>
                                <div className="row-four-div d-flex align-items-center main-row-container">
                                    <div className="score-value-div d-flex align-items-center">
                                        <p>251-400</p>
                                    </div>
                                    <div className="row-common-div row-four-one d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{lowBetween400And250?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-four-two d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{mediumBetween400And250?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-four-three d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{highBetween400And250?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-four-four d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{criticalBetween400And250?.length || 0}</p>
                                    </div>
                                </div>
                                <div className="row-five-div d-flex align-items-center main-row-container">
                                    <div className="score-value-div d-flex align-items-center">
                                        <p>0-250</p>
                                    </div>
                                    <div className="row-common-div row-five-one d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{lowLessThan250?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-five-two d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{mediumLessThan250?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-five-three d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{highLessThan250?.length || 0}</p>
                                    </div>
                                    <div className="row-common-div row-five-four d-flex align-items-center gap-2 p-2 justify-content-center">
                                        <p>{criticalLessThan250?.length || 0}</p>
                                    </div>
                                </div>
                                <div className="row-four-div d-flex align-items-center main-row-container">
                                    <div className="score-value-div d-flex align-items-center">

                                    </div>
                                    <div className="row-common-div d-flex align-items-center justify-content-center gap-2 p-2">
                                        <p>Low</p>
                                    </div>
                                    <div className="row-common-div d-flex align-items-center justify-content-center gap-2 p-2">
                                        <p>Medium</p>
                                    </div>
                                    <div className="row-common-div d-flex align-items-center justify-content-center gap-2 p-2">
                                        <p>High</p>
                                    </div>
                                    <div className="row-common-div d-flex align-items-center justify-content-center gap-2 p-2">
                                        <p>Critical</p>
                                    </div>
                                </div>
                                <div className="header-content dashboard-box-container d-flex align-items-center justify-content-center position-relative mt-4">
                                    <p className="heading">Business Impact</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                }                
            </div>
        </>
    )
}

export default VendorRiskVsBusinessImpact;